import storage from '@/storage/storage'
import { baseUrl } from '@/util/baseConfig'
import axios from 'axios'
import { ElLoading, ElMessage } from 'element-plus'
const instance = axios.create({
    // baseURL:"/api",
    // baseURL:"/",
    baseURL: baseUrl + "/BD",
    //  withCredentials: true // 允许携带cookie和认证头
    //  withCredentials: true ,
    headers:{
        'Content-Type': 'application/json;charset=UTF-8'
    }
    // timeout:5000
})
const openFullScreen2 = () => {
    const loading = ElLoading.service({
      lock: true,
      text: 'Loading',
      background: 'rgba(0, 0, 0, 0.7)',
    })
    return loading
  }
let loading
// 取消请求
instance.interceptors.request.use(async request => {
    const user = JSON.parse(storage.ls.get("user") || "{}") || {token: ""}
    request.headers['token'] = user.token || ""
    request.params = {
        ...request.params
    }
    request.data = {
        ...request.data
    }
    if(request.url.indexOf("export") != -1){
        request.responseType = "blob"
    }
    
    if(!(/^(\/admin\/report)/g).test(request.url)){
        loading = openFullScreen2()
    }else{
        function await_(){
            return new Promise((res) => {
                setTimeout(() => {
                    res()
                }, 800);
            })
        }
        await await_()
    }
    return request
})

const requestState = {
    1:() => {
        // ElMessage.success("查询成功")
    },
    0:() => {
        ElMessage.error("请求失败")
    }
}

instance.interceptors.response.use(response => {
    if(loading){
        loading.close()
    }
    if(response.status == 403){
        ElMessage.error("登录过期，请重新登录")
        storage.ls.clear()
        setTimeout(() => {
            window.location.href = "/login"
        })
    }
    console.log(response,'response');
    const { data } = response
    if(response.headers['content-type'] == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"){
        const blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = '导出文件.xlsx'; // 设置下载文件名，可根据实际修改
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(url);
        document.body.removeChild(a);
        return { code:1 }
    }
    // 如果存在就执行
    // requestState[data.code]?.()
    if(data.code != 1){
        ElMessage.error(data.msg)
        return Promise.reject(data.msg)
    }
    return {data:data.data,code:data.code}
},(err) => {
    if(loading){
        loading.close()
    }
    if(err.message == "Network Error"){
        return Promise.reject('网络异常')
        ElMessage.error("网络异常")
        }
    if(err.code == '"ECONNABORTED"'){
        ElMessage.error("请求超时")
        return Promise.reject("请求超时")
    }
    return Promise.reject(err.message)
})

export default instance